module.exports = __webpack_public_path__ + "static/media/print.e3f98ff7.gif";